const LIST_TRANSMISSION_VEHICLE = [
  {
    key: '',
    value: '',
    label: '',
  },
  {
    key: '0',
    value: 'All',
    label: 'Transmisi',
  },
  {
    key: '1',
    value: 'AT',
    label: 'AT',
  },
  {
    key: '2',
    value: 'MT',
    label: 'MT',
  },
]

export default LIST_TRANSMISSION_VEHICLE